import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function Admin() {
  const [key, setKey] = useState('');
  const [authed, setAuthed] = useState(false);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');

  const login = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const { data } = await axios.get(`/api/admin/records?key=${encodeURIComponent(key)}`);
      setRecords(data.records);
      setAuthed(true);
    } catch (err) {
      setError(err.response?.status === 401 ? 'Incorrect password.' : 'Failed to load records.');
    } finally {
      setLoading(false);
    }
  };

  const refresh = async () => {
    try {
      const { data } = await axios.get(`/api/admin/records?key=${encodeURIComponent(key)}`);
      setRecords(data.records);
    } catch (_) {}
  };

  const filtered = records.filter(r =>
    Object.values(r).some(v => v.toLowerCase().includes(search.toLowerCase()))
  );

  if (!authed) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#EEF3F8' }}>
        <div style={{ background: '#fff', borderRadius: 12, padding: '48px 40px', width: 380, boxShadow: '0 4px 24px rgba(0,0,0,0.10)' }}>
          <div style={{ textAlign: 'center', marginBottom: 28 }}>
            <div style={{ width: 52, height: 52, background: '#1B3A5C', borderRadius: '50%', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14 }}>
              <span style={{ color: '#fff', fontSize: 22 }}>🔐</span>
            </div>
            <h2 style={{ color: '#1B3A5C', fontSize: 20, fontWeight: 700, marginBottom: 6 }}>Admin Dashboard</h2>
            <p style={{ color: '#78909C', fontSize: 13 }}>Training Records — Odyssey Solutions</p>
          </div>
          <form onSubmit={login}>
            <input
              type="password"
              placeholder="Admin password"
              value={key}
              onChange={e => setKey(e.target.value)}
              style={{ width: '100%', padding: '11px 14px', border: '1.5px solid #DDE3ED', borderRadius: 8, fontSize: 14, marginBottom: 14, outline: 'none', boxSizing: 'border-box' }}
              autoFocus
            />
            {error && <p style={{ color: '#C53030', fontSize: 13, marginBottom: 10 }}>{error}</p>}
            <button
              type="submit"
              disabled={loading || !key}
              style={{ width: '100%', padding: '11px', background: '#1B3A5C', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: 'pointer', opacity: loading || !key ? 0.6 : 1 }}
            >
              {loading ? 'Loading…' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding: '32px 40px', maxWidth: 1100, margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
        <div>
          <h1 style={{ color: '#1B3A5C', fontSize: 22, fontWeight: 700, marginBottom: 4 }}>HIPAA Training Records</h1>
          <p style={{ color: '#78909C', fontSize: 13 }}>{records.length} total completion{records.length !== 1 ? 's' : ''}</p>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <input
            placeholder="Search name, email, role…"
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{ padding: '9px 14px', border: '1.5px solid #DDE3ED', borderRadius: 8, fontSize: 13, width: 240, outline: 'none' }}
          />
          <button onClick={refresh} style={{ padding: '9px 16px', background: '#EEF3F8', border: '1px solid #DDE3ED', borderRadius: 8, fontSize: 13, cursor: 'pointer', color: '#1B3A5C', fontWeight: 600 }}>
            Refresh
          </button>
        </div>
      </div>

      {filtered.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px 0', color: '#78909C', fontSize: 15 }}>
          {records.length === 0 ? 'No completions recorded yet.' : 'No results match your search.'}
        </div>
      ) : (
        <div style={{ overflowX: 'auto', borderRadius: 10, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', border: '1px solid #DDE3ED' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#1B3A5C', color: '#fff' }}>
                {['Certificate ID', 'Full Name', 'Email', 'Role', 'Completion Date', 'Valid Until', 'Timestamp'].map(h => (
                  <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, whiteSpace: 'nowrap' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map((r, i) => (
                <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#F8FAFC', borderBottom: '1px solid #EEF3F8' }}>
                  <td style={{ padding: '11px 16px', fontFamily: 'monospace', fontSize: 11, color: '#546E7A' }}>{r['Certificate ID']}</td>
                  <td style={{ padding: '11px 16px', fontWeight: 600, color: '#1B3A5C' }}>{r['Full Name']}</td>
                  <td style={{ padding: '11px 16px', color: '#2C3E50' }}>{r['Email']}</td>
                  <td style={{ padding: '11px 16px' }}>
                    <span style={{ background: '#EEF3F8', color: '#1B3A5C', padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap' }}>
                      {r['Role']}
                    </span>
                  </td>
                  <td style={{ padding: '11px 16px', color: '#2C3E50', whiteSpace: 'nowrap' }}>{r['Completion Date']}</td>
                  <td style={{ padding: '11px 16px', color: '#00A3A3', fontWeight: 600, whiteSpace: 'nowrap' }}>{r['Valid Until']}</td>
                  <td style={{ padding: '11px 16px', color: '#90A4AE', fontSize: 11, whiteSpace: 'nowrap' }}>{r['Timestamp']}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <p style={{ marginTop: 16, fontSize: 11, color: '#B0BEC5', textAlign: 'center' }}>
        Data sourced from Google Sheets — HIPAA Training Log · Odyssey Solutions
      </p>
    </div>
  );
}
